import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import get from "lodash/get";
import ReviewFormRow from "./ReviewFormRow";
import SectionHead from "./SectionHead";
import Dropdown from "../../../components/Dropdown/Dropdown";
import { aboutUsOptions, booleanOptions } from "consts/general";

const ReviewAffiliate = ({ onChange, onSubmit, formData }) => {
  const dispatch = useDispatch();
  const [errorMessage, setErrorMessage] = useState({});
  const signupToken = useSelector((state) => state.signup.signupToken || null);

  const onHasAffiliateValidation = (value) => {
    const used_affiliate_before =
      value || get(formData, "used_affiliate_before", "");
    if (used_affiliate_before === null) {
      setErrorMessage({
        ...errorMessage,
        used_affiliate_before: "Please select an option",
      });
      return true;
    }
    setErrorMessage({ ...errorMessage, used_affiliate_before: "" });
    return false;
  };

  const onHeardAboutUsValidation = (value) => {
    const rewards_hear_about_us_id = get(
      formData,
      "rewards_hear_about_us_id",
      ""
    );
    if (!rewards_hear_about_us_id) {
      setErrorMessage({
        ...errorMessage,
        rewards_hear_about_us_id: "Please select an option",
      });
      return true;
    }
    setErrorMessage({ ...errorMessage, rewards_hear_about_us_id: "" });
    return false;
  };

  return (
    <section>
      <SectionHead
        title="Affiliate & Referral"
        subtitle="Affiliate and referral information"
      />
      <div className="divide-y divide-gray-200">
        <ReviewFormRow
          label="Are you currently using affiliate links?"
          RowData={() => (
            <span className="capitalize">
              {
                booleanOptions.find(
                  (option) =>
                    (option.value === "yes" &&
                      formData?.used_affiliate_before) ||
                    (option.value === "no" && !formData?.used_affiliate_before)
                ).label
              }
            </span>
          )}
          onClick={() => {
            dispatch(
              onSubmit(
                {
                  signup_token: signupToken,
                  rewards_user: {
                    used_affiliate_before: formData.used_affiliate_before,
                  },
                },
                "registrations"
              )
            );
          }}
          EditForm={() => (
            <Dropdown
              placeholder="Please select"
              options={booleanOptions}
              value={booleanOptions.find(
                (option) =>
                  (option.value === "yes" && formData?.used_affiliate_before) ||
                  (option.value === "no" && !formData?.used_affiliate_before)
              )}
              onChange={(selected) => {
                if (selected?.value) {
                  onHasAffiliateValidation(selected);
                  onChange({
                    ...formData,
                    used_affiliate_before:
                      selected.value === "yes" ? true : false,
                  });
                }
              }}
              error={get(errorMessage, "used_affiliate_before", "")}
              required
            />
          )}
          onValidate={onHasAffiliateValidation}
        />
        <ReviewFormRow
          label="How did you hear about us?"
          RowData={() => (
            <span>
              {
                aboutUsOptions.find(
                  (option) =>
                    option.value === formData?.rewards_hear_about_us_id
                )?.label
              }
            </span>
          )}
          onClick={() => {
            dispatch(
              onSubmit(
                {
                  signup_token: signupToken,
                  rewards_user: {
                    rewards_hear_about_us_id: formData.rewards_hear_about_us_id,
                  },
                },
                "registrations"
              )
            );
          }}
          EditForm={() => (
            <Dropdown
              placeholder="Please select"
              options={aboutUsOptions}
              menuPlacement="top"
              value={aboutUsOptions.find(
                (option) => option.value === formData.rewards_hear_about_us_id
              )}
              onChange={(selected) => {
                if (selected?.value) {
                  onHeardAboutUsValidation(selected);
                  onChange({
                    ...formData,
                    rewards_hear_about_us_id: selected.value,
                  });
                }
              }}
              error={get(errorMessage, "rewards_hear_about_us_id", "")}
              required
            />
          )}
          onValidate={onHeardAboutUsValidation}
        />
      </div>
    </section>
  );
};

export default ReviewAffiliate;
